import { __decorate, __extends } from "tslib";
import { Editor } from '@tinymce/tinymce-react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { getConfig, update } from '../../api/config';
import { Button } from '../../components/Button';
import { DateSquare } from '../../components/DateSquare';
import { SpinnerBlock } from '../../components/Spinner';
import { getEditorKey, getEditorOptions, isHtmlEmpty } from '../../utils/utils';
import S from './reference.styl';
var ReferenceView = /** @class */ (function (_super) {
    __extends(ReferenceView, _super);
    function ReferenceView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false,
            referenceTitleError: false,
            referenceDescriptionError: false,
            referenceContentError: false,
            referenceImageError: false,
            referenceState: '',
        };
        _this.onChangeAction = function (e) {
            var name = e.currentTarget.name;
            if (name === 'referenceTitle') {
                _this.setState({ referenceTitleError: false });
            }
            if (name === 'referenceDescription') {
                _this.setState({ referenceDescriptionError: false });
            }
        };
        return _this;
    }
    ReferenceView.prototype.onSubmit = function (event) {
        var _this = this;
        event.preventDefault();
        var elements = event.currentTarget.elements;
        var valid = true;
        var referenceTitle = elements.referenceTitle.value;
        var referenceDescription = elements.referenceDescription.value;
        if (referenceTitle.length === 0) {
            this.setState({ referenceTitleError: true });
            valid = false;
        }
        if (referenceDescription.length === 0) {
            this.setState({ referenceDescriptionError: true });
            valid = false;
        }
        var html = this.referenceRef.getContent();
        if (isHtmlEmpty(html)) {
            this.setState({ referenceContentError: true });
            valid = false;
        }
        if (!valid) {
            return;
        }
        var request = {
            referencesTitle: referenceTitle,
            referencesDescription: referenceDescription,
            referencesContent: html,
        };
        this.setState({ loading: true });
        update(request).then(function (_) {
            _this.fetchData();
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    ReferenceView.prototype.componentDidMount = function () {
        var store = this.props.store;
        if (store) {
            this.fetchData();
        }
    };
    ReferenceView.prototype.fetchData = function () {
        var _this = this;
        this.setState({ loading: true });
        getConfig().then(function (result) {
            _this.setState({
                loading: false,
                config: result,
            });
            if (result) {
                _this.setState({
                    referenceState: result.referencesContent || '',
                });
            }
        }).catch(function (error) {
            alert(error.toString());
            throw error;
        });
    };
    ReferenceView.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state;
        var loading = state.loading, config = state.config, referenceState = state.referenceState;
        var i18n = props.store.i18n;
        var todayDate = new Date();
        return (React.createElement("div", { className: S.referenceView },
            React.createElement("div", { className: S.referenceHeaderContainer },
                React.createElement(DateSquare, { className: S.dateSquare, date: todayDate, size: 40 }),
                React.createElement("h1", { className: "moduleTitle" }, i18n.sideBarReferences),
                React.createElement("div", { className: S.dayNotesContainer },
                    React.createElement("span", { className: S.dayNotesDate }, i18n.formatMediumDate(todayDate)))),
            React.createElement("hr", { className: "moduleSeparator" }),
            React.createElement("div", { className: S.referenceMainBox }, loading ?
                React.createElement(SpinnerBlock, null)
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("form", { className: "" + S.addDialogContent, method: "get", action: "/", onSubmit: this.onSubmit, noValidate: true },
                            React.createElement("div", null,
                                React.createElement("p", { className: "formSubtitle" }, i18n.inputTitlePlaceholder),
                                React.createElement("div", { className: S.addInputWrapper },
                                    React.createElement("label", { className: S.addInputTitle }, i18n.inputTitlePlaceholder),
                                    React.createElement("input", { className: S.addInput + " textInput", name: "referenceTitle", autoComplete: "title", onInput: this.onChangeAction, placeholder: i18n.inputTitlePlaceholder, defaultValue: config === null || config === void 0 ? void 0 : config.referencesTitle })),
                                React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.referenceTitleError ? 'inputErrorActive' : '') }, i18n.validationTitleError),
                                React.createElement("p", { className: "formSubtitle" }, i18n.inputDescriptionTitle),
                                React.createElement("div", { className: S.addInputWrapper },
                                    React.createElement("label", { className: S.addInputTitle }, i18n.inputDescriptionTitle),
                                    React.createElement("input", { className: S.addInput + " textInput", name: "referenceDescription", autoComplete: "title", onInput: this.onChangeAction, placeholder: i18n.inputDescriptionTitle, defaultValue: config === null || config === void 0 ? void 0 : config.referencesDescription })),
                                React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.referenceDescriptionError ? 'inputErrorActive' : '') }, i18n.validationDescriptionError),
                                React.createElement("p", { className: "formSubtitle" }, i18n.inputTitleContent),
                                React.createElement(Editor, { onInit: function (_, editor) { return _this.referenceRef = editor; }, apiKey: getEditorKey(), initialValue: referenceState, init: getEditorOptions() }),
                                React.createElement("p", { className: "inputError " + S.detailsInputError + " " + (this.state.referenceContentError ? 'inputErrorActive' : '') }, i18n.validationIndicationError)),
                            React.createElement(Button, { className: "primaryButton fullwidthButton " + S.referenceButton, type: "submit", spinner: loading }, i18n.actionUpdate))))));
    };
    __decorate([
        action.bound
    ], ReferenceView.prototype, "onSubmit", null);
    ReferenceView = __decorate([
        inject('store'),
        observer
    ], ReferenceView);
    return ReferenceView;
}(React.Component));
export { ReferenceView };
